export default "__VITE_ASSET__DQKYtvIe__"